define('datasource-manager/lib/extend',['require','exports','module'],function(require,exports,module){
	function extend(target,source,source2){
		var key;
		for(key in source){
			if(source.hasOwnProperty(key)||all){
				target[key]=source[key];
			}
		}
		if(source2){
			extend(target,source2);
		}
		return target;			
	}
	return extend;
});
